import { render, staticRenderFns } from "./TransportationEmojiLabelField.vue?vue&type=template&id=1c4bf85e"
import script from "./TransportationEmojiLabelField.vue?vue&type=script&lang=ts&setup=true"
export * from "./TransportationEmojiLabelField.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports